import React, { useState } from "react";

function TestOrder() {
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const [inputs, setInputs] = useState({
    driverId: 14,
    lat: 36.532960623944845,
    lon: 2.82227563210055,
    deliveries: [
      {
        id: "5",
        price: 1100,
        shipping: 200,
        phoneNumber: "0656549870",
        address: "Blida",
      },
    ],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("delivery_")) {
      const field = name.replace("delivery_", "");
      setInputs((prev) => ({
        ...prev,
        deliveries: [
          {
            ...prev.deliveries[0],
            [field]:
              field === "price" || field === "shipping"
                ? parseInt(value)
                : value,
          },
        ],
      }));
    } else {
      setInputs((prev) => ({
        ...prev,
        [name]:
          name === "lat" || name === "lon" ? parseFloat(value) : value,
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResult(null);
    setError(null);

    const mutation = `
      mutation {
        createTestOrder(input: {
          driverId: ${inputs.driverId},
          deliveries: [{
            id: "${inputs.deliveries[0].id}",
            price: ${inputs.deliveries[0].price},
            shipping: ${inputs.deliveries[0].shipping},
            phoneNumber: "${inputs.deliveries[0].phoneNumber}",
            lat: ${inputs.lat},
            lon: ${inputs.lon},
            address: "${inputs.deliveries[0].address}",
          }]
        })
      }
    `;
    const isDev = process.env.NODE_ENV === "development";
    const endpoint = isDev
      ? "http://localhost:3031/graphql"
      : "https://api.burgred.net/api/graphql";
    try {
      const res = await fetch(endpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ query: mutation }),
      });
      const data = await res.json();
      if (data.errors) {
        setError(data.errors[0].message);
      } else {
        setResult(data.data.createTestOrder);
      }
    } catch (err) {
      setError("Network error");
    }
    setLoading(false);
  };

  return (
    <div style={{ padding: "20px" }}>
      <p>Create Test Order</p>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Driver ID: </label>
          <input
            name="driverId"
            type="number"
            value={inputs.driverId}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Latitude: </label>
          <input
            name="lat"
            type="number"
            step="any"
            value={inputs.lat}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Longitude: </label>
          <input
            name="lon"
            type="number"
            step="any"
            value={inputs.lon}
            onChange={handleChange}
          />
        </div>
        <h3>Delivery Details</h3>
        <div>
          <label>Delivery ID: </label>
          <input
            name="delivery_id"
            type="text"
            value={inputs.deliveries[0].id}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Price: </label>
          <input
            name="delivery_price"
            type="number"
            value={inputs.deliveries[0].price}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Shipping: </label>
          <input
            name="delivery_shipping"
            type="number"
            value={inputs.deliveries[0].shipping}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Phone Number: </label>
          <input
            name="delivery_phoneNumber"
            type="text"
            value={inputs.deliveries[0].phoneNumber}
            onChange={handleChange}
          />
        </div>
        <div>
          <label>Address: </label>
          <input
            name="delivery_address"
            type="text"
            value={inputs.deliveries[0].address}
            onChange={handleChange}
          />
        </div>
        <button type="submit" disabled={loading} style={{ marginTop: "10px" }}>
          {loading ? "Submitting..." : "Submit"}
        </button>
      </form>
      {result && (
        <div style={{ marginTop: "10px", color: "green" }}>
          Success: {JSON.stringify(result)}
        </div>
      )}
      {error && (
        <div style={{ marginTop: "10px", color: "red" }}>
          Error: {error}
        </div>
      )}
    </div>
  );
}

export default TestOrder;
